import { render } from "./FbnAdditionalFiling.vue?vue&type=template&id=40693318"
import script from "./FbnAdditionalFiling.vue?vue&type=script&lang=js"
export * from "./FbnAdditionalFiling.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__